export default "/images/vendor/flag-icon-css/flags/4x3/sk.svg?031f7d1211a3a7f59010135d65c54d9b";